import { Component, OnInit, Input } from '@angular/core';
import { GridData } from 'src/app/matrix-component/grid-list/gridData.model';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { IdValue } from 'src/app/matrix-component/grid-list/idvalue.model';
import { LuggageCategory } from 'src/app/models/LuggageCategory.model';
import { PassengerChangeTimeVectorSteps } from 'src/app/models/PassengerChangeTimeVectorSteps.model';
import { FactorSetSteps, factorSetStepsNaming } from 'src/app/models/FactorSet.model';
import { CloneService } from 'src/app/services/clone.service';
import { PassengerChangeTimeVectorStepsData } from './PassengerChangeTimeVectorStepsData.model';

@Component({
  selector: 'app-passenger-change-time-vector-steps',
  templateUrl: './passenger-change-time-vector-steps.component.html',
  styleUrls: ['./passenger-change-time-vector-steps.component.scss']
})
export class PassengerChangeTimeVectorStepsComponent implements OnInit {

  constructor(private _formBuilder: FormBuilder,private cloneService:CloneService) { }


  ngOnInit() {
    this.form = this.parentForm;
    this.form.addControl('passengerChangeTimeVectorSteps', this._formBuilder.array([]));
    this.form.setControl('passengerChangeTimeVectorSteps', this.asFormGroup(this.data));
    this.lascCtrl = this.form.get('passengerChangeTimeVectorSteps');
    this.lascCtrl= this.lascCtrl.get('values');
    this.data.values =  this.lascCtrl.value as FactorSetSteps[];
    this.gridData_1=this.ConvertData(1);
    this.gridData_2=this.ConvertData(2);
  }
  asFormGroup(o: PassengerChangeTimeVectorSteps): FormGroup {
    const fg = new FormGroup({
      id: new FormControl(o.id, Validators.required),
      regionId: new FormControl(o.regionId, Validators.required),
      values: new FormControl(o.values, Validators.required)
    });
    return fg;
  }
  @Input('form') parentForm: FormGroup;
  @Input('data') data: PassengerChangeTimeVectorSteps;
  @Input('rowHeaders') rowHeaders: LuggageCategory[];
  @Input('isEditable') isEditable: boolean;
  @Input('timeType') timeType: boolean;
  gridData_1: GridData=new GridData();
  gridData_2: GridData=new GridData();

  form: FormGroup;
  lascCtrl;

  ConvertData(timeTypeId:number): GridData {
    let matrix:PassengerChangeTimeVectorStepsData[] = [];

    for (let i = 0; i < this.data.values.length; i++) {
      const valueEntry = this.data.values[i];
      if(valueEntry.timeTypeId != timeTypeId)
      {
        continue;
      }
        let data:PassengerChangeTimeVectorStepsData = new PassengerChangeTimeVectorStepsData;
        data.factorSetStepsId=timeTypeId===1 ? 1 : 4;
        data.luggageCategoryId=valueEntry.additionalId;
        data.value=valueEntry.steps1Value;
        data.timeTypeId=timeTypeId;
        data.id=valueEntry.id;
        matrix.push(data);
        let data2:PassengerChangeTimeVectorStepsData = new PassengerChangeTimeVectorStepsData;
        data2.factorSetStepsId=timeTypeId===1 ? 2 : 5;
        data2.luggageCategoryId=valueEntry.additionalId;
        data2.value=valueEntry.steps2Value;
        data2.timeTypeId=timeTypeId;
        data2.id=valueEntry.id;
        matrix.push(data2);
        let data3:PassengerChangeTimeVectorStepsData = new PassengerChangeTimeVectorStepsData;
        data3.factorSetStepsId=timeTypeId===1 ? 3 : 6;
        data3.luggageCategoryId=valueEntry.additionalId;
        data3.value=valueEntry.steps3Value;
        data3.timeTypeId=timeTypeId;
        data3.id=valueEntry.id;
        matrix.push(data3);
    }
    let rowHeaders: IdValue[] = [];
    for (let i = 0; i < this.rowHeaders.length; i++) {
      const headerEntry = this.rowHeaders[i];
      rowHeaders.push(new IdValue(headerEntry.id,headerEntry.name));
    }

    let colHeaders: IdValue[] = [];
    if(timeTypeId===1)
    {
      for (let i = 0; i < 3; i++) {
        const headerEntry = factorSetStepsNaming[i];
        colHeaders.push(new IdValue(headerEntry.id,headerEntry.name));
      }
    }
    else if(timeTypeId===2)
    {
      for (let i = 3; i < 6; i++) {
        const headerEntry = factorSetStepsNaming[i];
        colHeaders.push(new IdValue(headerEntry.id,headerEntry.name));
      }
    }
    
    let grid: GridData = new GridData();
    grid.colHeaders = colHeaders;
    grid.rowHeaders = rowHeaders;
    grid.matrix = matrix.sort((a, b) => a.luggageCategoryId - b.luggageCategoryId);
    grid.colProp = 'factorSetStepsId';
    grid.rowProp = 'luggageCategoryId';
    grid.switchColWithRow = false;
    return grid;
  }
  normalize(temp: PassengerChangeTimeVectorStepsData[]) {
    let tmp:FactorSetSteps[] = [];
    let allIds:number[] = temp.map(m=>m.id);

    let uniqueIds:number[] = [];
    uniqueIds.push(allIds[0]);
    for (let index = 0; index < allIds.length; index++) {
      const element = allIds[index];
      let check:boolean=true;
      for (let index = 0; index < uniqueIds.length; index++) {
        const element2 = uniqueIds[index];
        if(element===element2)
        {
          check=false;
        }
      }
      if(check==true)
      {
        uniqueIds.push(element);
      }
    }

    for (let i = 0; i < uniqueIds.length; i++) {
      const tmpData = uniqueIds[i];
      let tmpFactorSetSteps:FactorSetSteps = new FactorSetSteps;
      for (let i = 0; i < temp.length; i++) {
        const tmpData2 = temp[i];
        if(tmpData==tmpData2.id && tmpData2.factorSetStepsId==1)
        {
          tmpFactorSetSteps.steps1Value=tmpData2.value;
          tmpFactorSetSteps.timeTypeId=tmpData2.timeTypeId;
          tmpFactorSetSteps.id=tmpData2.id;
          tmpFactorSetSteps.additionalId=tmpData2.luggageCategoryId;
        }
        if(tmpData==tmpData2.id && tmpData2.factorSetStepsId==2)
        {
          tmpFactorSetSteps.steps2Value=tmpData2.value;
          tmpFactorSetSteps.timeTypeId=tmpData2.timeTypeId;
          tmpFactorSetSteps.id=tmpData2.id;
          tmpFactorSetSteps.additionalId=tmpData2.luggageCategoryId;
        }
        if(tmpData==tmpData2.id && tmpData2.factorSetStepsId==3)
        {
          tmpFactorSetSteps.steps3Value=tmpData2.value;
          tmpFactorSetSteps.timeTypeId=tmpData2.timeTypeId;
          tmpFactorSetSteps.id=tmpData2.id;
          tmpFactorSetSteps.additionalId=tmpData2.luggageCategoryId;
        }
        if(tmpData==tmpData2.id && tmpData2.factorSetStepsId==4)
        {
          tmpFactorSetSteps.steps1Value=tmpData2.value;
          tmpFactorSetSteps.timeTypeId=tmpData2.timeTypeId;
          tmpFactorSetSteps.id=tmpData2.id;
          tmpFactorSetSteps.additionalId=tmpData2.luggageCategoryId;
        }
        if(tmpData==tmpData2.id && tmpData2.factorSetStepsId==5)
        {
          tmpFactorSetSteps.steps2Value=tmpData2.value;
          tmpFactorSetSteps.timeTypeId=tmpData2.timeTypeId;
          tmpFactorSetSteps.id=tmpData2.id;
          tmpFactorSetSteps.additionalId=tmpData2.luggageCategoryId;
        }
        if(tmpData==tmpData2.id && tmpData2.factorSetStepsId==6)
        {
          tmpFactorSetSteps.steps3Value=tmpData2.value;
          tmpFactorSetSteps.timeTypeId=tmpData2.timeTypeId;
          tmpFactorSetSteps.id=tmpData2.id;
          tmpFactorSetSteps.additionalId=tmpData2.luggageCategoryId;
        }
      }
      tmp.push(tmpFactorSetSteps);
    }
    this.data.values=tmp;
  }
  save()
  {
    
    let clonedGridData = this.cloneService.deepClone(this.gridData_1.matrix) as PassengerChangeTimeVectorStepsData[];
    let clonedGridData2 = this.cloneService.deepClone(this.gridData_2.matrix) as PassengerChangeTimeVectorStepsData[];
    var clonedGridDataConcated = clonedGridData.concat(clonedGridData2);
    this.normalize(clonedGridDataConcated);
    
    if(this.lascCtrl !== null)
    {
      this.lascCtrl.patchValue(this.data.values);
    }
  }
}
